import React from 'react';
const pains = [{
  icon: '😰',
  title: 'Ogni settimana ricominci tutto da capo',
  items: ['Preparare valutazioni.', 'Creare nuove attività.', 'Pianificare gli interventi.', 'Scrivere gli obiettivi terapeutici.', 'Adattare ogni seduta.', 'Preparare la documentazione.', 'Personalizzare il materiale.'],
  body: 'E prima ancora di iniziare il primo paziente... hai già trascorso ore davanti al computer.'
}, {
  icon: '🤔',
  title: 'Ogni paziente presenta esigenze completamente diverse',
  items: ['Alcuni hanno deficit neurologici.', 'Altri difficoltà cognitive.', 'Altri problemi motori.', 'Altri necessitano di riabilitazione funzionale.', 'Altri richiedono adattamenti ambientali.'],
  body: 'Ogni caso richiede modifiche, strategie e materiale specifico. Creare tutto manualmente richiede tantissimo tempo.'
}, {
  icon: '📚',
  title: 'Hai tantissimo materiale... ma niente è davvero organizzato',
  items: ['Libri.', 'PDF.', 'Video.', 'Corsi.', 'Appunti.', 'Cartelle.'],
  body: 'Negli anni hai accumulato moltissime informazioni. Ma ogni volta devi cercare, confrontare, modificare e ricostruire tutto. Ti manca un unico sistema professionale già pronto.'
}, {
  icon: '😩',
  title: 'Passi più tempo a preparare le sedute che a lavorare con i pazienti',
  items: ['Valutazioni...', 'Programmi...', 'Attività...', 'Documentazione...', 'Monitoraggio...', 'Relazioni cliniche...'],
  body: 'Dedichi sempre più tempo al lavoro dietro lo schermo che al trattamento dei tuoi pazienti.'
}];
export function PainSection() {
  return <section className="border-y border-brand-line bg-brand-cloud px-4 py-5" data-id="element-104" data-mp="3dvw1t3v0l46v">
      <div className="mx-auto max-w-4xl" data-id="element-105" data-mp="3dtt1nr05duof">
        <h2 className="mb-2 text-center font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-3xl" data-id="element-106" data-mp="2q59rt71g99u8">
          TI RITROVI IN UNA DI QUESTE SITUAZIONI?
        </h2>
        <p className="mx-auto mb-4 max-w-3xl text-center text-sm font-medium leading-snug text-brand-slate sm:text-base" data-id="element-107" data-mp="p4bzndvt2rrb">
          Ami aiutare i tuoi pazienti a migliorare la loro autonomia e qualità di vita. Ma preparare ogni intervento richiede sempre più tempo. Se lavori come Terapista Occupazionale in ambito pediatrico, neurologico, geriatrico, riabilitativo, domiciliare o privato, probabilmente conosci molto bene queste situazioni.
        </p>
        <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-108" data-mp="6710rue360ce">
          {pains.map(pain => <article key={pain.title} className="flex gap-3 rounded-xl border border-brand-line bg-white p-3 shadow-sm" data-id="element-109" data-mp="b4az5zjgdmcd">
              <span className="shrink-0 text-2xl" aria-hidden="true" data-id="element-110" data-mp="f7z5kewcmbw1">{pain.icon}</span>
              <div data-id="element-111" data-mp="k2mmnsp0w40l">
                <h3 className="mb-1 font-display text-sm font-bold uppercase leading-tight tracking-wide text-brand-navy sm:text-base" data-id="element-112" data-mp="1qkt8hfui3s3y">
                  {pain.title}
                </h3>
                <ul className="mb-1 grid list-inside list-disc grid-cols-2 gap-x-2 text-xs font-semibold leading-snug text-brand-slate marker:text-brand-sky sm:text-sm" data-id="element-113" data-mp="1vlpdxxui3mbh">
                  {pain.items.map(item => <li key={item} data-id="element-114" data-mp="20r2kgukywb1i">{item}</li>)}
                </ul>
                <p className="text-xs font-medium leading-snug text-brand-slate sm:text-sm" data-id="element-115" data-mp="1vwgj7k8lnyv5">{pain.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}